import Dropzone from 'dropzone/dist/dropzone';
import pdfjsLib from 'pdfjs-dist';

import 'vendor/frame-grab.js_hacked/client/lib/rsvp.js';
import 'vendor/frame-grab.js_hacked/client/frame-grab.js';

'use strict';

var ad_inputFile = function () {
  var self = this;

  self.init();

};

ad_inputFile.prototype.bind = function () {
  var self = this;

  // console.log('bind ad_inputFile');

  jQuery(document).arrive('.ad_inputFile', self.init_inputFile);

};

ad_inputFile.prototype.init = function () {
  var self = this;

  self.init_inputFile();
  self.bind();
};

ad_inputFile.prototype.init_inputFile = function () {
  //var self = this;

  // console.log('init ad_inputFile');

  Dropzone.autoDiscover = false;

  jQuery('.ad_inputFile').each(
    function (/*index*/) {
      var element = jQuery(this);

      if (element.hasClass('st_mounted') === false) {
        var hiddenInputContainer = '#' + element.attr('id');
        var url = element.attr('data-url');
        // debugger

        var mode = '';
        var dictDefaultMessage = '';
        var maxFiles = null;

        if (element.hasClass('ly_singleInput')) {
          mode = 'input';
        } else if (element.hasClass('ly_pdfInput')) {
          mode = 'input_pdf';
        } else if (element.hasClass('ly_videoInput')) {
          mode = 'input_video';
        }
        else if (element.hasClass('ly_singleFile')) {
          mode = 'single';
          dictDefaultMessage = '<i class="material-icons ad_inputFile_el_dropZoneIcon">' + 'insert_drive_file' + '</i>' + '<p class="ad_inputFile_el_dropZoneDummy">' + 'Drag & Drop your file here. Or <u>Browse</u>' + '</p>';
          maxFiles = 1;
        } else if (element.hasClass('ly_multipleFiles')) {
          mode = 'multiple';
          dictDefaultMessage = '<i class="material-icons ad_inputFile_el_dropZoneIcon">' + 'insert_drive_file' + '</i>' + '<p class="ad_inputFile_el_dropZoneDummy">' + 'Drag & Drop your files here. Or <u>Browse</u>' + '</p>';
        }

        // Dropzone form element
        var dropzoneForm = element.find('.ad_inputFile_el_dropZone');

        // Html Template
        var template = jQuery('#ad_inputFile_el_dropZoneTemplate')[0].innerHTML;


        if (mode === 'input') {

          var hidden_input = element.find('.ad_inputFile_el_singleInput');

          hidden_input.on('change', function (event) {

            var hidden_input_2 = jQuery(this);
            var component = hidden_input_2.closest('.ad_inputFile');
            var img = component.find('.ad_inputFile_backgroundImage img');


            if (event.target.files[0].type.indexOf('image') === -1) {
              // console.log('El archivo no es una imagen');
            } else {
              if ( window.FileReader) {
                var reader = new FileReader();
                reader.onload = function (localImg, localEvent) {

                  localImg.attr('src', localEvent.target.result);

                }.bind(null, img);

                reader.readAsDataURL(event.target.files[0]);

              }
            }

          });

        }



        if (mode === 'input_pdf') {
          var hidden_input_pdf = element.find('.ad_inputFile_el_singleInput');

          hidden_input_pdf.on('change', function (/*event*/) {

            var hidden_input_2 = jQuery(this);
            var component = hidden_input_2.closest('.ad_inputFile');
            var img_element = component.find('.ad_inputFile_backgroundImage img');

            var pdf_file = hidden_input_2[0].files[0];


            var file_type_raw = event.target.files[0].type;
            var file_type = file_type_raw.substr(file_type_raw.lastIndexOf('/')).toLowerCase();

            if (file_type === '/pdf') {
              // console.log('Tenemos un pdf');

              var pdf_file_url = URL.createObjectURL( pdf_file );
              PDFJS.getDocument( pdf_file_url ).then(
                function(local_component, pdf) {

                  pdf.getPage(1).then(

                    function(local_component_2, page) {

                      var scale = 1;
                      var viewport = page.getViewport(scale);
                      // var viewport_height = viewport.height;
                      // var viewport_width = viewport.width;

                      var canvas = local_component_2.find('.ad_inputFile_canvas')[0];
                      var context = canvas.getContext('2d');
                      canvas.height = viewport.height;
                      canvas.width = viewport.width;
                      var renderContext = {
                        canvasContext: context,
                        viewport: viewport
                      };

                      var renderTask = page.render(renderContext);

                      renderTask.promise.then(
                        function(local_component_3) {
                          var canvas_2 = local_component_3.find('.ad_inputFile_canvas')[0];
                          var img_binary = canvas_2.toDataURL('image/jpg');

                          var img = local_component_3.find('.ad_inputFile_backgroundImage img');
                          img.attr('src', img_binary);

                          var hidden_input_3 = local_component_3.find('.ad_inputFile_hidden_jpg_preview');
                          hidden_input_3[0].setAttribute('value', img_binary);

                        }.bind(null, local_component_2)
                      );


                    }.bind(null, local_component)
                  );
                }.bind(null, component)
              );

            } else if (file_type === '/jpg' || file_type === '/jpeg') {
              if ( window.FileReader) {
                var reader = new FileReader();
                reader.onload = function (localImg, localEvent) {

                  localImg.attr('src', localEvent.target.result);

                }.bind(null, img_element);

                reader.readAsDataURL(event.target.files[0]);

              }
            }



          });

        }

        if (mode === 'input_video') {

          var hidden_input_video = element.find('.ad_inputFile_el_singleInput');

          hidden_input_video.on('change', function (event) {

            var hidden_input_2 = jQuery(this);
            var component = hidden_input_2.closest('.ad_inputFile');
            var bk_img = component.find('.ad_inputFile_backgroundImage');
            // var img = bk_img.find('img');

            var file = event.target.files[0];

            var comps = file.name.split('.');
            if (comps.length === 1 || (comps[0] === '' && comps.length === 2)) {
                return;
            }
            var ext = comps.pop().toLowerCase();
            if ( ext === 'mp4' ) {
              // console.log('tenemos un video mp4');

              FrameGrab.blob_to_video(file).then(
                  function videoRendered(local_bk_img, videoEl) {

                    local_bk_img.html(videoEl);
                    local_bk_img.find('video').get(0).play();

                  }.bind(null, bk_img),
                  function videoFailedToRender(/*reason*/) {
                    // console.log('Can\'t convert the file to a video element: ' + file.name + '. Reason: ' + reason);
                  }
              );

            } else {
              // console.log('El archivo no es un video');
            }

          });

        }






        if (mode === 'multiple') {
          dropzoneForm.dropzone({
            dictDefaultMessage: dictDefaultMessage,
            // addRemoveLinks: false,
            hiddenInputContainer: hiddenInputContainer,
            paramName: element.data('param-name'),
            url: url,
            maxFiles: maxFiles,
            previewTemplate: template,
            maxfilesexceeded: function (/*File*/) {
              // console.log('Se ha excedido el número máximo de Archivos permitidos en ad_inputFile');                  console.log('Se ha excedido el número máximo de Archivos permitidos en ad_inputFile');
            },
            success: function(file/*, response*/){
              this.removeFile(file);
              jQuery.getScript(element.data('success-url'));
            },
            error: function(file, response){
              this.removeFile(file);
              var time = new Date().getTime();
              var error_notification = jQuery('<div>', {'id': time, 'class': 'hidden', 'data-width': '360px', 'data-type': 'error'});
              jQuery.each(response.errors, function( index, value ) {
                error_notification.append(jQuery('<p>').text(value));
              });
              jQuery('body').append(error_notification);
              window.ad_notification.html_selector('#' + time);
            }
          });
        }

        if (mode === 'single') {

          dropzoneForm.dropzone({
            dictDefaultMessage: dictDefaultMessage,
            // addRemoveLinks: false,
            hiddenInputContainer: hiddenInputContainer,
            paramName: element.data('param-name'),
            url: url,
            maxFiles: maxFiles,
            previewTemplate: template,
            thumbnailWidth: 300,
            thumbnailHeight: 300,
            maxfilesexceeded: function (/*File*/) {
              // console.log('Se ha excedido el número máximo de Archivos permitidos en ad_inputFile');
              //debugger

              var filesToKill = [];

              // Guardamos todos los archivos excepto el último que se a añadido.
              for (var i = 0; i < (this.files.length - 1); i++) {

                var file = this.files[i];

                filesToKill.push(file);

                // console.log(file.name);
              }

              for (var j = 0; j < filesToKill.length; j++) {

                this.removeFile(filesToKill[j]);
              }



            },
            thumbnail: function (file, dataUrl) {


              // Borramos el elemento de carga de la imagen
              //this.removeFile(file);

              // Obtenemos el thumbnail de la imagen
              var src = dataUrl;

              // Generamos el tag de img
              var img = '<img src="' + src + '">';

              var parent = jQuery(this.element).closest('.ad_inputFile');
              var backgroundImage = parent.find('.ad_inputFile_backgroundImage');

              //Insert Image
              backgroundImage.html(img);

            },
            success: function(file/*, response*/){
              this.removeFile(file);

            },
            error: function(/*file*//*, response*/){



            }
          });

        }// end else


        element.addClass('st_mounted');

      }
    }
  );

};


jQuery( document ).ready(function() {

  window.ad_inputFile = new ad_inputFile();

});
